<div class="edit-verified">
  <div>
    <div>Verified:</div>
    <div *ngIf="!isInEditMode">
      <span *ngIf="customerInput?.isVerified">Yes</span>
      <span *ngIf="!customerInput?.isVerified">No</span>
      <span *ngIf="customerInput?.isVerified" style="margin-left: 2em">{{
        customerInput.verificationExpireDate | date : dateFormat
      }}</span>
      <a class="edit-button" style="margin-left: 1em" (click)="onEditClick()"
        ><i class="fa fa-pencil-square-o"></i
      ></a>
    </div>
    <div *ngIf="isInEditMode">
      <div>
        <input type="checkbox" [(ngModel)]="customerInput.isVerified" />
        <hr-field-state-marker
          [field]="field?.isVerified"
        ></hr-field-state-marker>
      </div>
      <div>
        <p-datepicker
          [dateFormat]="specialDateFormat"
          [(ngModel)]="customerInput.verificationExpireDate"
          [showIcon]="true"
        ></p-datepicker>
        <hr-field-state-marker
          [field]="field?.verificationExpireDate"
        ></hr-field-state-marker>
      </div>
      <button (click)="onSaveClick()" style="margin-left: 4em">
        {{ 'label.Save' | translate }}
      </button>
      <button (click)="onCancelClick()">
        {{ 'label.Cancel' | translate }}
      </button>
    </div>
  </div>
  <div></div>
</div>
